import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`


  html {
    scroll-behavior: smooth;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body, html {
    background-color: #000000;
    color: #ffffff;
    font-family: 'Arial', sans-serif;
    line-height: 1.6;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  #root {
    height: 100%;
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
  }

  .navbar {
    position: sticky;
    top: 0;
    background: #333;
    color: #fff;
    padding: 1rem;
    z-index: 1000;
  }
`;

export default GlobalStyle;